export default {"src":"/_next/static/media/SplineD_Pg1Dark_720x720.1318cb7d.svg","height":720,"width":720,"blurWidth":0,"blurHeight":0};